export const MAX_COUNTER_PCS_PER_BRANCH = 1;

export function isActiveDevice(device) {
  const status = (device?.status || '').toLowerCase();
  return status === 'active';
}

export function getDeviceBranchId(device) {
  const branch = device?.branchId;
  if (!branch) return null;
  return typeof branch === 'object' ? branch._id : branch;
}

export function branchHasActiveCounterPc(branchId, devices = []) {
  if (!branchId) return false;
  return devices.some(
    (device) => isActiveDevice(device) && String(getDeviceBranchId(device)) === String(branchId),
  );
}

/** Slot consumed — includes revoked/inactive PCs; disconnect does not free it. */
export function branchHasCounterPcSlotUsed(branchId, devices = [], branches = []) {
  if (!branchId) return false;

  const branch = (branches || []).find((b) => String(b._id) === String(branchId));
  if (branch?.counterPcSlotUsed) return true;
  if ((branch?.activationKeysIssued || 0) >= MAX_COUNTER_PCS_PER_BRANCH) return true;

  return devices.some(
    (device) => String(getDeviceBranchId(device)) === String(branchId),
  );
}

export function getBranchesAvailableForCounterPc(branches = [], devices = []) {
  return branches.filter(
    (branch) =>
      branch.status === 'active' &&
      !branchHasCounterPcSlotUsed(branch._id, devices, branches),
  );
}

export function canConnectCounterPc(branches = [], devices = []) {
  return getBranchesAvailableForCounterPc(branches, devices).length > 0;
}

export function getCounterPcForBranch(branchId, devices = [], { activeOnly = false } = {}) {
  return devices.find((device) => {
    if (String(getDeviceBranchId(device)) !== String(branchId)) return false;
    return activeOnly ? isActiveDevice(device) : true;
  });
}

/** @deprecated Use branchHasActiveCounterPc */
export function branchHasCounterPc(branchId, devices = []) {
  return branchHasActiveCounterPc(branchId, devices);
}

/** @deprecated Use getBranchesAvailableForCounterPc */
export function getBranchesWithoutCounterPc(branches = [], devices = []) {
  return getBranchesAvailableForCounterPc(branches, devices);
}